
export enum DeliveryBasis {
    "ELEVATOR" = "ELEVATOR",
    "PICKUP" = "PICKUP",
    "EXW" = "EXW",
    "FOB" = "FOB",
    "WAGON" = "WAGON"
}
